export const typographyTokens = {
  fontFamilies: {
    pretendard: 'Pretendard',
  },
  lineHeights: {
    0: '120%',
    1: '150%',
    2: '140%',
    3: '100%',
  },
  fontWeights: {
    pretendard: {
      bold: 700,
      semiBold: 600,
      medium: 500,
      regular: 400,
    },
  },
  fontSize: {
    0: '10px',
    1: '12px',
    2: '14px',
    3: '16px',
    4: '18px',
    5: '20px',
    6: '24px',
    7: '28px',
    8: '32px',
    9: '40px',
    10: '48px',
  },
  letterSpacing: {
    0: '0%',
  },
  paragraphSpacing: {
    0: '0',
  },
} as const;

export const typography = {
  heading: {
    h1: `
      font-family: ${typographyTokens.fontFamilies.pretendard};
      font-weight: ${typographyTokens.fontWeights.pretendard.semiBold};
      line-height: ${typographyTokens.lineHeights[0]};
      font-size: ${typographyTokens.fontSize[10]};
      letter-spacing: ${typographyTokens.letterSpacing[0]};
      paragraph-spacing: ${typographyTokens.paragraphSpacing[0]};
    `,
    h2: `
      font-family: ${typographyTokens.fontFamilies.pretendard};
      font-weight: ${typographyTokens.fontWeights.pretendard.semiBold};
      line-height: ${typographyTokens.lineHeights[0]};
      font-size: ${typographyTokens.fontSize[9]};
      letter-spacing: ${typographyTokens.letterSpacing[0]};
      paragraph-spacing: ${typographyTokens.paragraphSpacing[0]};
    `,
    h3: `
      font-family: ${typographyTokens.fontFamilies.pretendard};
      font-weight: ${typographyTokens.fontWeights.pretendard.semiBold};
      line-height: ${typographyTokens.lineHeights[0]};
      font-size: ${typographyTokens.fontSize[8]};
      letter-spacing: ${typographyTokens.letterSpacing[0]};
      paragraph-spacing: ${typographyTokens.paragraphSpacing[0]};
    `,
    h4: `
      font-family: ${typographyTokens.fontFamilies.pretendard};
      font-weight: ${typographyTokens.fontWeights.pretendard.semiBold};
      line-height: ${typographyTokens.lineHeights[0]};
      font-size: ${typographyTokens.fontSize[7]};
      letter-spacing: ${typographyTokens.letterSpacing[0]};
      paragraph-spacing: ${typographyTokens.paragraphSpacing[0]};
    `,
    h5: `
      font-family: ${typographyTokens.fontFamilies.pretendard};
      font-weight: ${typographyTokens.fontWeights.pretendard.semiBold};
      line-height: ${typographyTokens.lineHeights[0]};
      font-size: ${typographyTokens.fontSize[6]};
      letter-spacing: ${typographyTokens.letterSpacing[0]};
      paragraph-spacing: ${typographyTokens.paragraphSpacing[0]};
    `,
    h6: `
      font-family: ${typographyTokens.fontFamilies.pretendard};
      font-weight: ${typographyTokens.fontWeights.pretendard.semiBold};
      line-height: ${typographyTokens.lineHeights[0]};
      font-size: ${typographyTokens.fontSize[5]};
      letter-spacing: ${typographyTokens.letterSpacing[0]};
      paragraph-spacing: ${typographyTokens.paragraphSpacing[0]};
    `,
  },
  subtitle: {
    subtitle1: `
      font-family: ${typographyTokens.fontFamilies.pretendard};
      font-weight: ${typographyTokens.fontWeights.pretendard.semiBold};
      line-height: ${typographyTokens.lineHeights[1]};
      font-size: ${typographyTokens.fontSize[4]};
      letter-spacing: ${typographyTokens.letterSpacing[0]};
      paragraph-spacing: ${typographyTokens.paragraphSpacing[0]};
    `,
    subtitle2: `
      font-family: ${typographyTokens.fontFamilies.pretendard};
      font-weight: ${typographyTokens.fontWeights.pretendard.semiBold};
      line-height: ${typographyTokens.lineHeights[1]};
      font-size: ${typographyTokens.fontSize[3]};
      letter-spacing: ${typographyTokens.letterSpacing[0]};
      paragraph-spacing: ${typographyTokens.paragraphSpacing[0]};
    `,
  },
  paragraph: {
    p1: {
      default: `
        font-family: ${typographyTokens.fontFamilies.pretendard};
        font-weight: ${typographyTokens.fontWeights.pretendard.regular};
        line-height: ${typographyTokens.lineHeights[1]};
        font-size: ${typographyTokens.fontSize[3]};
        letter-spacing: ${typographyTokens.letterSpacing[0]};
        paragraph-spacing: ${typographyTokens.paragraphSpacing[0]};
      `,
      medium: `
        font-family: ${typographyTokens.fontFamilies.pretendard};
        font-weight: ${typographyTokens.fontWeights.pretendard.medium};
        line-height: ${typographyTokens.lineHeights[1]};
        font-size: ${typographyTokens.fontSize[3]};
        letter-spacing: ${typographyTokens.letterSpacing[0]};
        paragraph-spacing: ${typographyTokens.paragraphSpacing[0]};
      `,
    },
    p2: {
      default: `
        font-family: ${typographyTokens.fontFamilies.pretendard};
        font-weight: ${typographyTokens.fontWeights.pretendard.regular};
        line-height: ${typographyTokens.lineHeights[1]};
        font-size: ${typographyTokens.fontSize[2]};
        letter-spacing: ${typographyTokens.letterSpacing[0]};
        paragraph-spacing: ${typographyTokens.paragraphSpacing[0]};
      `,
      medium: `
        font-family: ${typographyTokens.fontFamilies.pretendard};
        font-weight: ${typographyTokens.fontWeights.pretendard.medium};
        line-height: ${typographyTokens.lineHeights[1]};
        font-size: ${typographyTokens.fontSize[2]};
        letter-spacing: ${typographyTokens.letterSpacing[0]};
        paragraph-spacing: ${typographyTokens.paragraphSpacing[0]};
      `,
    },
  },
  label: {
    label1: `
      font-family: ${typographyTokens.fontFamilies.pretendard};
      font-weight: ${typographyTokens.fontWeights.pretendard.medium};
      line-height: ${typographyTokens.lineHeights[2]};
      font-size: ${typographyTokens.fontSize[1]};
      letter-spacing: ${typographyTokens.letterSpacing[0]};
      paragraph-spacing: ${typographyTokens.paragraphSpacing[0]};
      text-transform: uppercase;
    `,
  },
  caption: {
    caption1: {
      default: `
        font-family: ${typographyTokens.fontFamilies.pretendard};
        font-weight: ${typographyTokens.fontWeights.pretendard.regular};
        line-height: ${typographyTokens.lineHeights[2]};
        font-size: ${typographyTokens.fontSize[1]};
        letter-spacing: ${typographyTokens.letterSpacing[0]};
        paragraph-spacing: ${typographyTokens.paragraphSpacing[0]};
      `,
      medium: `
        font-family: ${typographyTokens.fontFamilies.pretendard};
        font-weight: ${typographyTokens.fontWeights.pretendard.medium};
        line-height: ${typographyTokens.lineHeights[2]};
        font-size: ${typographyTokens.fontSize[1]};
        letter-spacing: ${typographyTokens.letterSpacing[0]};
        paragraph-spacing: ${typographyTokens.paragraphSpacing[0]};
      `,
    },
    caption2: `
      font-family: ${typographyTokens.fontFamilies.pretendard};
      font-weight: ${typographyTokens.fontWeights.pretendard.medium};
      line-height: ${typographyTokens.lineHeights[2]};
      font-size: ${typographyTokens.fontSize[1]};
      letter-spacing: ${typographyTokens.letterSpacing[0]};
      paragraph-spacing: ${typographyTokens.paragraphSpacing[0]};
    `,
    caption3: `
      font-family: ${typographyTokens.fontFamilies.pretendard};
      font-weight: ${typographyTokens.fontWeights.pretendard.medium};
      line-height: ${typographyTokens.lineHeights[2]};
      font-size: ${typographyTokens.fontSize[0]};
      letter-spacing: ${typographyTokens.letterSpacing[0]};
      paragraph-spacing: ${typographyTokens.paragraphSpacing[0]};
    `,
  },
  button: {
    button1: `
      font-family: ${typographyTokens.fontFamilies.pretendard};
      font-weight: ${typographyTokens.fontWeights.pretendard.semiBold};
      line-height: ${typographyTokens.lineHeights[3]};
      font-size: ${typographyTokens.fontSize[5]};
      letter-spacing: ${typographyTokens.letterSpacing[0]};
    `,
      button2: `
      font-family: ${typographyTokens.fontFamilies.pretendard};
      font-weight: ${typographyTokens.fontWeights.pretendard.semiBold};
      line-height: ${typographyTokens.lineHeights[3]};
      font-size: ${typographyTokens.fontSize[4]};
      letter-spacing: ${typographyTokens.letterSpacing[0]};
    `,
    button3: `
      font-family: ${typographyTokens.fontFamilies.pretendard};
      font-weight: ${typographyTokens.fontWeights.pretendard.semiBold};
      line-height: ${typographyTokens.lineHeights[3]};
      font-size: ${typographyTokens.fontSize[3]};
      letter-spacing: ${typographyTokens.letterSpacing[0]};
    `,
    button4: `
      font-family: ${typographyTokens.fontFamilies.pretendard};
      font-weight: ${typographyTokens.fontWeights.pretendard.medium};
      line-height: ${typographyTokens.lineHeights[3]};
      font-size: ${typographyTokens.fontSize[2]};
      letter-spacing: ${typographyTokens.letterSpacing[0]};
    `,
    button5: `
      font-family: ${typographyTokens.fontFamilies.pretendard};
      font-weight: ${typographyTokens.fontWeights.pretendard.medium};
      line-height: ${typographyTokens.lineHeights[3]};
      font-size: ${typographyTokens.fontSize[1]};
      letter-spacing: ${typographyTokens.letterSpacing[0]};
    `,
  },
} as const; 